import { combineReducers } from "redux";
import axios from "../api/api";

export const asc = () => async (dispatch, getState) => {};

export const apiCall = () => async (dispatch, getState) => {
  const response = await axios.get("/apiCall");
  dispatch({ type: "API_DATA", payload: response.data });
};
export const ascCall = (user) => async (dispatch, getState) => {
  await dispatch({ type: "LOGGED", payload: true });
  await dispatch({ type: "ASC_ID", payload: user });
  const route = await axios.get("/getEditor/All", {
    asc: user,
  });
  const sheetList = await axios.get(`/getEditor/${user}`);
  await dispatch({ type: "ASC_DATA", payload: route.data });
  await dispatch({
    type: "GET_SHEET",
    payload: sheetList.data.sheetList,
  });
  await dispatch({ type: "DROP", payload: false });
};

export const chooseEdit = () => async (dispatch, getState) => {
  if (window.localStorage.getItem("user")) {
    await dispatch(ascCall(window.localStorage.getItem("user")));
  } else if (getState().isLoggedIn) {
    await dispatch(ascCall(getState().ascId));
  }
};

export const getUser = (user) => async (dispatch, getState) => {
  await dispatch({ type: "CURRENT_USER", payload: user });
  await dispatch({ type: "LOGGED", payload: true });
};

export const getLogout = (state = false) => {
  return {
    type: "LOGGED",
    payload: state,
  };
};

export const callEditor = (user) => async (dispatch, getState) => {
  try {
    const response = await axios.get(`/editorFetch/${user}`);
    dispatch({ type: "EDITOR", payload: response.data.editor });
  } catch (error) {
    console.log(error);
  }
};

export const setDrop = (state) => {
  return {
    type: "DROP",
    payload: state,
  };
};

export const loginCall = (user, form) => async (dispatch, getState) => {
  try {
    const res = await axios.get("/apiCall");
    await dispatch({ type: "API_DATA", payload: res.data });
    const response = await axios.post("/signin", { ...form });
    await dispatch({ type: "CURRENT_USER", payload: response.data });
    await dispatch({ type: "LOGGED", payload: true });
    if (user === "asc") {
      window.localStorage.setItem("user", getState().user.asc._id);
      await dispatch(chooseEdit());
    } else if (user === "editor") {
      await dispatch({ type: "EDITOR", payload: response.data.editor });
      // dispatch(callEditor(response.data.editor._id));
    }
    // case "editor":
    // window.localStorage.setItem("isLoggedinEditor", true);
    // window.localStorage.setItem("EditorID", response.data.editor._id);
    // await dispatch({ type: "LOGGED", payload: true });

    // console.log("not user");
  } catch (error) {
    // dispatch({ type: "LOGGED", payload: false });
    console.log(error);
  }
};
